import {
  DataTable,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect } from "react";

const PaginatedDataTable = ({ children, headers, items, onPageChange, page, pageSize, totalElements, getCellContent, paginate }) => {

  useEffect(() => {
  }, [items]);

  return (
    <>
      <DataTable rows={items} headers={headers} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            {children && (<TableToolbar aria-label="data table toolbar">
              <TableToolbarContent>
                {children}
              </TableToolbarContent>
            </TableToolbar>)}
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      {paginate && (<Pagination
        backwardText="Previous page"
        forwardText="Next page"
        itemsPerPageText="Items per page:"
        page={page}
        pageNumberText="Page Number"
        pageSize={pageSize}
        pageSizes={[
          20,
          50,
          75,
          100
        ]}
        totalItems={totalElements}
        onChange={onPageChange}
      />)}
    </>

  );
};

PaginatedDataTable.defaultProps = {
  paginate: true,
};

export default PaginatedDataTable;
